import { hash } from '@ember/helper';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import { pluralize } from '@warp-drive/utilities/string';
import { t } from 'ember-intl';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import { eq } from 'ember-truth-helpers';

import modelIcon from 'umg-ember-backend/helpers/model-icon';
import { getBem } from 'umg-ember-backend/utils/get-bem';

import Item from '../item';
import styles from './styles.module.css';

const bem = getBem(styles);

export default class ApplicationNavigationGroupComponent extends Component {
  // Services
  @service breadcrumb;
  @service intl;
  @service router;
  @tracked _isOpen;

  // Getter and setter
  get label() {
    let key = this.args.group.key;

    return this.intl.t(`application.navigation.group.${key}`);
  }

  get isChildActive() {
    return this.args.group.children?.some((child) => {
      if (child.type === 'section') {
        return false;
      }

      const route = child.route ?? `admin.${pluralize(child.key)}`;

      if (this.breadcrumb.firstRoute) {
        return this.breadcrumb.firstRoute?.routeName.includes(route);
      }

      return this.router.currentRouteName?.includes(route);
    });
  }

  get isOpen() {
    return this._isOpen ?? this.isChildActive;
  }

  // Functions
  toggleGroup = () => {
    this._isOpen = !this.isOpen;
  };

  // Template
  <template>
    <li
      class={{bem
        (hash is-open=this.isOpen is-child-active=this.isChildActive)
      }}
      ...attributes
    >
      <button
        type='button'
        class={{bem 'label'}}
        aria-expanded={{this.isOpen}}
        {{on 'click' this.toggleGroup}}
      >
        {{svgJar (modelIcon @group.key) class=(bem 'model-icon')}}
        {{this.label}}
        {{svgJar 'chevron-right' class=(bem 'chevron')}}
      </button>
      <ul class={{bem 'items'}}>
        {{#each @group.children as |child|}}
          {{#if (eq child.type 'section')}}
            <li class={{bem 'section'}}>
              <span class={{bem 'section-label'}}>{{t child.key}}</span>
            </li>
          {{else}}
            <Item
              @isChild={{true}}
              @item={{child}}
              @onCloseNavigation={{@onCloseNavigation}}
            />
          {{/if}}
        {{/each}}
      </ul>
    </li>
  </template>
}
